import { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";
import { cn } from "@/lib/utils";

export default function StrategyName({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const containerRef = useRef<HTMLDivElement>(null);
  const measureRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    const check = () => {
      if (!containerRef.current || !measureRef.current) return;

      setIsOverflowing(
        measureRef.current.scrollWidth > containerRef.current.clientWidth,
      );
    };

    check();

    const observer = new ResizeObserver(check);
    containerRef.current && observer.observe(containerRef.current);

    window.addEventListener("resize", check);

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", check);
    };
  }, [name]);

  return (
    <div
      ref={containerRef}
      className={cn(
        "relative overflow-hidden min-w-0 whitespace-nowrap text-muted-foreground font-semibold",
        className,
      )}
    >
      {/* hidden measuring text */}
      <div
        ref={measureRef}
        className="absolute opacity-0 pointer-events-none whitespace-nowrap"
      >
        {name}
      </div>

      {isOverflowing ? (
        <Marquee speed={40} gradient={false} pauseOnHover>
          <span className="pr-6">{name}</span>
        </Marquee>
      ) : (
        <div className="truncate">{name}</div>
      )}
    </div>
  );
}
